export default{'swalPromiseResolve':new WeakMap(),'swalPromiseReject':new WeakMap()};